import React from 'react';
import { navigate } from 'gatsby';
import style from './style.module.scss';
import ButtonPrimary from '../ButtonPrimary';
import { connect } from 'react-redux';
import { Bounce, Zoom } from 'react-reveal';
import { toggleContact } from '../../state/actions/index';
import CookingBackground from '../../images/background_cooking_icons.png'
import EventsBackground from '../../images/events_icons/events_inverse.png'
import ReactPlayer from 'react-player'
import ReachOutCTA from '../ReachOutCTA';

const MeetBimboLayout = props => {
  const facebookVideoUrl = 'https://www.facebook.com/BimboPuertoRico/videos/636631450089994/',
    appId = '334485120808775';

  return (
    <div>
      <section className={style.video}>
        <ReactPlayer
          className='react-player'
          width='100%'
          height='100%'
          url={facebookVideoUrl}
          config={{
            facebook: {
              appId: { appId }
            }
          }}
        />

        {/* <ButtonPrimary
          label="WATCH"
          type="red"
          size="medium"
          onClick={() => navigate('/home')}>
        </ButtonPrimary> */}
      </section>

      <section className={style.aboutSection}>
        <Bounce top> <span className={style.aboutSectionTitle}>ABOUT</span></Bounce>
        <Bounce bottom>
          <p className={style.aboutSectionText}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
            magna aliqua.
            Dictum fusce ut placerat orci nulla. Tellus orci ac auctor augue mauris augue. Volutpat ac tincidunt vitae
            semper quis.
            Pharetra sit amet aliquam id diam. Donec enim diam vulputate ut. Semper viverra nam libero justo laoreet sit.
            Laoreet non curabitur gravida arcu ac tortor dignissim convallis aenean.
        </p>
        </Bounce>
      </section>

      <ReachOutCTA backgroundColor="lightBlue" backgroundImage={CookingBackground} onClickCTA={() => props.dispatch(toggleContact(true, 'bimbo'))} />
    </div>
  );
};

export default connect()(MeetBimboLayout);

